//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { format } from 'date-fns'
import RouteName from '../../../../utils/RouteName'
import { Spa2Route } from '@/ExternalRoutes'
import BaseIcon from '@/components/reusable-components/basics/BaseIcon.vue'

export default {
    components: {
        BaseIcon,
    },
    props: {
        notification: { type: Object, required: true },
    },
    data() {
        return {
            isActive: false,
        }
    },
    computed: {
        iconName: function() {
            switch (this.notificationAttr.name) {
                case 'CalendarIcon':
                    return `event_available`
                case 'FeedbackIcon':
                    return `feedback`
                case 'NewConnectionIcon':
                    return `link`
                case 'ThumbUpIcon':
                    return `thumb-up-1`
                case 'campaign':
                    return `campaign`
                default:
                    return ''
            }
        },
        iconColor: function() {
            switch (this.notification.type) {
                case 'event_confirmation':
                case 'sponsorship':
                case 'event_invitation_accepted':
                    return '#00bb9c'

                case 'event_vip':
                case 'feedback_event':
                case 'feedback_relationship':
                case 'relationship':
                case 'relationship_cc':
                    return '#093d58'

                case 'event_update':
                    return 'yellow'
                default:
                    return null
            }
        },
        notificationDate: function() {
            const date = format(this.notification.created_at, 'DD/MM/YYYY')
            return `le ${date}`
        },
        notificationText: function() {
            const actionText = ['event_vip'].includes(this.notification.type)
                ? '. <strong>' + this.notification.cta + '</strong>'
                : ''

            return [this.notification.subject, this.notification.action, this.notification.object]
                .map((text, i) => {
                    if (!text) {
                        return null
                    }

                    let textHtmlEl = null

                    // Subject and object in bold
                    if (i === 2) {
                        textHtmlEl = '<strong>' + text + '</strong>'
                    } else {
                        textHtmlEl = text
                    }

                    return textHtmlEl
                })
                .filter(text => !!text)
                .join(' ')
                .concat(actionText)
        },
        notificationAttr: function() {
            switch (this.notification.type) {
                case 'event_invitation_accepted':
                case 'event_vip':
                case 'event_update':
                case 'event_confirmation':
                case 'event_participation_accepted':
                    return { type: 'icon', name: 'CalendarIcon' }
                case 'feedback_event':
                    return { type: 'icon', name: 'FeedbackIcon' }
                case 'feedback_relationship':
                    return { type: 'icon', name: 'FeedbackIcon' }
                // return { type: 'icon', name: 'ThumbUpIcon' }
                case 'relationship':
                case 'relationship_cc':
                    return { type: 'icon', name: 'NewConnectionIcon' }
                case 'sponsorship':
                    return { type: 'icon', name: 'ThumbUpIcon' }
                case 'message':
                    return {
                        type: 'picture',
                        src: this.notification.data.picture,
                    }
                case 'relationship_suggest':
                    return {
                        type: 'icon',
                        name: 'campaign',
                    }
                default:
                    return {}
            }
        },
    },
    mounted() {
        this.markNotificationAsRead()
    },
    methods: {
        onClickNotification() {
            let action = null
            let parameter = null

            /**
             * Temporaire: pour l'app mobile tant que les feedbacks des connexions business ne sont pas implémentées, nous devons
             * empêcher de rediiger vers la home et afficher le feedback. Donc on enlève le path pour le mobile et il faut continuer a le gérer sur le web.
             */
            if (this.notification.data.feedbackId) {
                return this.redirect(`/?__fb=${this.notification.data.feedbackId}`)
            }

            if (this.notification.data && this.notification.data && this.notification.data.path) {
                this.notification.data.parsedParams = this.notification.data.path.split('/').filter(param => !!param)

                action = this.notification.data.parsedParams[0]
                parameter = this.notification.data.parsedParams[1]
            }

            switch (action) {
                case 'events': // Will do the same as below
                case 'event':
                    this.redirect(`/event/${parameter}/see`)
                    break
                case 'member':
                case 'members':
                    this.redirect(`/member/${this.notification.data.memberIdFF}`)
                    break
                case 'business_history':
                    if (this.notification.data.parsedParams[2]) {
                        this.redirect(Spa2Route.INBOX(this.notification.data.parsedParams[2]))
                    } else {
                        this.redirect('/member')
                    }
                    break
                case 'feedbacks':
                    this.redirect(`/?__fb=${this.notification.data.feedbackId}`)
                    break
                case 'relationship_suggest':
                   window.analytics?.track('leclub:relationship_suggestions:display')
                    this.$router.push({
                        name: RouteName.MEMBER,
                        params: { memberId: this.notification.data.memberIdFF },
                    })
                    break
                default:
                    null
            }
        },
        markNotificationAsRead() {
            if (this.notification.displayed_at) {
                return null
            }

            window.$.ajax({
                method: 'PUT',
                url: '/notifications/' + this.notification.id + '/displayed',
            })
        },
        redirect(route) {
            window.location.replace(route)
        },
    },
}
